import type { QueryClient } from "@tanstack/react-query";

// Shared React Query key for the tenant-config read. Kept here (not inline in
// the hook) so both the hook and the invalidation path reference one constant.
export const TENANT_CONFIG_QUERY_KEY = "tenantConfig";

// Force-refresh the cached tenant-config for every tenant/hostname variant.
// The config is cached client-side, so subscription changes (e.g. a city being
// unsubscribed) won't reach an already-open storefront session until the cache
// revalidates. Call this to invalidate it on demand. Typed against just the
// method used so it's trivial to unit-test with a stub.
export const invalidateTenantConfig = (
  queryClient: Pick<QueryClient, "invalidateQueries">
) => queryClient.invalidateQueries({ queryKey: [TENANT_CONFIG_QUERY_KEY] });
